import React, { Component } from 'react'
import styles from './styles.scss'

import { TimelineMax, TweenMax, Power3 } from 'gsap'

import resize from 'src/utils/resize'
import values from 'src/values'
import components from 'src/utils/components'
import Scroller from 'src/utils/scroller'

export default class ScrollMore extends Component {
  componentDidMount() {
    this.onResize()

    resize.add(this.onResize, this.key)
  }

  componentDidUpdate() {
    this.onResize()
  }

  onClick = () => {
    Scroller.scrollTo(
      components.allComponents.homeWorld.topComponent - 70,
      0.4
    ).then()
  }

  onResize = () => {
    if (!this.refs.component) return
    this.hComponent = this.refs.component.offsetHeight
    this.wComponent = this.refs.component.offsetWidth
  }

  render() {
    return (
      <div
        onClick={this.onClick}
        ref="component"
        className="component scroll-more wrapper">
        <span className="line" />
        <p className="btn">{this.props.content}</p>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home/components/scroll-more/index.js